const DEVTOOLS_ENABLED_VALUES = new Set(["true", "1", "yes", "on"]);
const SUPPORTED_ENVIRONMENTS = new Set(["local", "dev", "qa", "development"]);

export function shouldEnableReactQueryDevtools(
  environment: string | undefined,
  devtoolsFlag: string | undefined
): boolean {
  const normalizedEnvironment = (environment ?? "").trim().toLowerCase();
  const normalizedDevtoolsFlag = (devtoolsFlag ?? "").trim().toLowerCase();

  return (
    SUPPORTED_ENVIRONMENTS.has(normalizedEnvironment) &&
    DEVTOOLS_ENABLED_VALUES.has(normalizedDevtoolsFlag)
  );
}
